import React from "react";
import { useAppContext } from "../../helpers/account-context";
import { toPermalink } from "../../helpers/helper";
import { ResultLine } from "./Mixin";

const BASIC_FIELDS = [
  {
    label: "Name",
    value: "name",
  },
  {
    label: "Location Type",
    value: "location_type_name",
  },
  {
    label: "Address",
    value: "full_address",
  },
  {
    label: "Phone",
    value: "phone",
  },
  {
    label: "Website",
    value: "url",
  },
];

const FieldText = (props) => {
  const { fieldName, fieldValue } = props;
  const { getLocale, account } = useAppContext();
  if (fieldName === "phone")
    return (
      <a href={`tel:${fieldValue}`} className="cbmap-link">
        {fieldValue}
      </a>
    );
  if (fieldName === "email")
    return (
      <a href={`mailto:${fieldValue}`} className="cbmap-link">
        {fieldValue}
      </a>
    );
  if (fieldName === "url")
    return (
      <a
        href={`${fieldValue}`}
        target={account.cta_open || `_blank`}
        className="cbmap-link"
      >
        {getLocale("visit_website")}
      </a>
    );
  return <span>{fieldValue}</span>;
};

export const FieldsResult = (props) => {
  const { item, fieldName, hiddenLabel = false } = props;

  const afield = BASIC_FIELDS.find((ff) => ff.value === fieldName);
  let fieldValue = null;
  let fieldLabel = fieldName;

  if (afield) {
    fieldValue = item.properties[fieldName];
    fieldLabel = afield.label;
  }

  if (!fieldValue) return null;

  return (
    <ResultLine className={`cbmap-item_${toPermalink(fieldName)}`}>
      {!hiddenLabel && (
        <div className="cbmap-details-prop-name">{fieldLabel}</div>
      )}

      <FieldText fieldName={fieldName} fieldValue={fieldValue} />
    </ResultLine>
  );
};

export const FieldsDetail = (props) => {
  const { item, fieldName, hiddenLabel = false } = props;

  const afield = BASIC_FIELDS.find((ff) => ff.value === fieldName);
  let fieldValue = null;
  let fieldLabel = fieldName;

  if (afield) {
    fieldValue = item.properties[fieldName];
    fieldLabel = afield.label;
  }

  if (!fieldValue) return null;

  return (
    <div
      key={`cbmap-details_${toPermalink(fieldName)}`}
      className={`cbmap-details-prop cbmap-details_${toPermalink(fieldName)}`}
    >
      {!hiddenLabel && (
        <div className="cbmap-details-prop-name">{fieldLabel}</div>
      )}

      <FieldText fieldName={fieldName} fieldValue={fieldValue} />
    </div>
  );
};
export const FieldsInfowin = (props) => {
  const { item, fieldName, hiddenLabel = false } = props;

  const afield = BASIC_FIELDS.find((ff) => ff.value === fieldName);
  let fieldValue = null;
  let fieldLabel = fieldName;

  if (afield) {
    fieldValue = item.properties[fieldName];
    fieldLabel = afield.label;
  }

  if (!fieldValue) return null;

  return (
    <div
      key={`cbmap-infowin_${toPermalink(fieldName)}`}
      className={`cbmap-infowin-prop cbmap-infowin_${toPermalink(fieldName)}`}
    >
      {!hiddenLabel && (
        <div className="cbmap-infowin-prop-name">{fieldLabel}</div>
      )}

      <FieldText fieldName={fieldName} fieldValue={fieldValue} />
    </div>
  );
};
